export default __webpack_public_path__ + "static/candyhearts-40b27f8906a85afecbd1609eebd5dbd5.png";